import { isEmptyOrBlank } from "@axtesys/react-tools"

export type User = {
  firstName: string
  lastName: string
}

type NameSanitizationArgs = {
  lastName: string
  firstName?: string
  inverse?: boolean
}

export function sanitizeName(args?: NameSanitizationArgs): string {
  if (!args) return ""

  const { firstName, lastName, inverse } = args

  const name = !isEmptyOrBlank(firstName)
    ? inverse ?? false
      ? `${lastName} ${firstName}`
      : `${firstName} ${lastName}`
    : lastName

  return !isEmptyOrBlank(name) ? name : ""
}

export function sanitizeNameInverse(
  args?: Omit<NameSanitizationArgs, "inverse">,
): string {
  if (!args) return ""

  return sanitizeName({ ...args, inverse: true })
}
